import { useEffect } from "react";

const styles = {
  body: {
    margin: 0,
    padding: 0,
    background: "#06080f",
    minHeight: "80vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    fontFamily: "serif",
  },
  grain: {
    position: "fixed",
    inset: 0,
    pointerEvents: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.05'/%3E%3C/svg%3E")`,
    opacity: 0.5,
    zIndex: 0,
  },
  glow: {
    position: "fixed",
    width: "700px",
    height: "400px",
    background:
      "radial-gradient(ellipse, rgba(100, 120, 255, 0.07) 0%, transparent 70%)",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    animation: "breathe 8s ease-in-out infinite",
    zIndex: 0,
  },
  wrap: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    userSelect: "none",
  },
  coming: {
    display: "block",
    fontFamily: "'Cormorant Garamond', serif",
    fontWeight: 200,
    fontSize: "clamp(32px, 7vw, 68px)",
    letterSpacing: "10px",
    textTransform: "uppercase",
    color: "rgba(210, 215, 240, 0.55)",
    animation: "revealComing 1.4s cubic-bezier(0.16, 1, 0.3, 1) both",
    animationDelay: "0.2s",
  },
  soon: {
    display: "block",
    fontFamily: "'Cormorant Garamond', serif",
    fontWeight: 200,
    fontStyle: "italic",
    fontSize: "clamp(80px, 18vw, 180px)",
    lineHeight: 0.85,
    color: "#d8dcf5",
    letterSpacing: "-4px",
    animation: "revealSoon 1.2s cubic-bezier(0.16, 1, 0.3, 1) both",
    animationDelay: "0.7s",
  },
  line: {
    display: "block",
    height: "1px",
    background:
      "linear-gradient(90deg, transparent, rgba(160,170,230,0.4), transparent)",
    margin: "28px auto 0",
    animation: "fadeInLine 1.2s ease both",
    animationDelay: "1.4s",
    maxWidth: "320px",
  },
};

const keyframes = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,200;1,200&display=swap');

  @keyframes breathe {
    0%, 100% { opacity: 0.6; transform: translate(-50%, -50%) scale(1); }
    50%       { opacity: 1;   transform: translate(-50%, -50%) scale(1.1); }
  }

  @keyframes revealComing {
    0%   { opacity: 0; letter-spacing: 40px; transform: translateY(20px); }
    100% { opacity: 1; letter-spacing: 10px; transform: translateY(0); }
  }

  @keyframes revealSoon {
    0%   { opacity: 0; transform: translateY(40px) skewY(3deg); }
    100% { opacity: 1; transform: translateY(0)    skewY(0deg); }
  }

  @keyframes fadeInLine {
    from { width: 0;    opacity: 0; }
    to   { width: 100%; opacity: 1; }
  }
`;

export default function ComingSoon() {
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = keyframes;
    document.head.appendChild(styleTag);
    return () => document.head.removeChild(styleTag);
  }, []);

  return (
    <div style={styles.body}>
      <div style={styles.grain} />
      <div style={styles.glow} />
      <div style={styles.wrap}>
        <span style={styles.coming}>Coming</span>
        <span style={styles.soon}>Soon</span>
        <span style={styles.line} />
      </div>
    </div>
  );
}